import React from "react";

import { FlightCircuitCanvas as FlightCircuitCanvasComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";
interface FlightPathAndEyeTrackingProps {
    isInsideModal?: boolean;
    subDimensionsData?: any;
}

const FlightPathAndEyeTracking: React.FC<FlightPathAndEyeTrackingProps> = ({
    isInsideModal,
    subDimensionsData,
}: FlightPathAndEyeTrackingProps) => {
    const {
        flightCircuitData,
        gazeData,
        isErrorGazeData,
        isFetchingFlightCircuit,
        isErrorFlightCircuit,
        isFetchingGazeData,
        isErrorSubDimensions,
        isFetchingSubDimensions,
    } = useSessionDetailsContext();

    //Avoid hardcoding the key for the data.
    const circuitKey = Object.keys(flightCircuitData ?? {})[0];
    const gazeKey = Object.keys(gazeData ?? {})[0];

    let combinedData = {
        flyingData: flightCircuitData?.[circuitKey],
        eyeTrackingData: gazeData?.[gazeKey],
    };

    let onlyPartialData = false;

    const hasSubDimensionData =
        subDimensionsData?.flyingData?.pathData?.flightData?.length > 0 &&
        subDimensionsData?.eyeTrackingData?.length > 0;

    const hasCombinedData =
        combinedData.flyingData?.pathData?.flightData?.length > 0 &&
        combinedData.eyeTrackingData?.length > 0;

    const hasOnlyFlight =
        subDimensionsData?.flyingData?.pathData?.flightData?.length > 0 &&
        !subDimensionsData?.eyeTrackingData;

    if (hasOnlyFlight && gazeData) {
        combinedData = {
            ...subDimensionsData,
            eyeTrackingData: gazeData,
        };
    } else {
        onlyPartialData = true;
    }

    const isEmptyState =
        (!subDimensionsData && !hasOnlyFlight) ||
        (!hasSubDimensionData && !hasOnlyFlight) ||
        (isErrorSubDimensions && !hasOnlyFlight) ||
        (!subDimensionsData && isErrorGazeData) ||
        (!subDimensionsData && isErrorFlightCircuit && !hasOnlyFlight) ||
        (!hasSubDimensionData && !hasCombinedData && !hasOnlyFlight) ||
        onlyPartialData;

    if (isFetchingSubDimensions || isFetchingFlightCircuit || isFetchingGazeData) {
        return <ContentLoader height="22.9375rem" />;
    }

    if (isEmptyState) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:flight-circuit:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                />
            </ComponentWrapper>
        );
    }

    if (!subDimensionsData && isErrorSubDimensions && !isFetchingSubDimensions) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                />
            </ComponentWrapper>
        );
    }

    return (
        <FlightCircuitCanvasComponent
            data={subDimensionsData && !hasOnlyFlight ? subDimensionsData : combinedData}
            isInsideModal={isInsideModal}
        />
    );
};

export default FlightPathAndEyeTracking;
